module.exports = __webpack_public_path__ + "static/media/icn_close.0ee8b3e2.svg";